import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  GenericIconName,
  Icon,
  Modal,
  ProductImageDetails,
  UnstyledButton,
} from '@aboutyou/ui-components';
import {exists} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

export interface ProductImageDetailsModalViewProps {
  isOpen: boolean;
  currentIndex: number | undefined;
  onClose: () => void;
}

export const ProductImageDetailsModalView: FC<
  GetProductBulkResponse['imagesSection'] & ProductImageDetailsModalViewProps
> = ({images, isOpen, onClose, currentIndex}) => {
  const {t} = useTranslation();
  const uiImages = images
    .map(group => group.image)
    .filter(image => exists(image))
    .map(image => ({
      padded: image!.isEnclosed,
      src: image!.src,
      alt: image!.description,
    }));

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      bodyContent={
        <>
          <CloseButton
            data-testid="modalCloseIcon"
            aria-label={t('Close')}
            onClick={onClose}
          >
            <Icon asset={GenericIconName.Close} size="M" />
          </CloseButton>
          <ProductImageDetails
            currentOuterIndex={currentIndex}
            images={uiImages}
          />
        </>
      }
    />
  );
};

const CloseButton = styled(UnstyledButton)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 24px;
  z-index: 1;
`;
